import React, { useEffect, useMemo } from 'react';
import './OnboardingFinish.css';
import ThemedButton from './ThemedButton';
import { UserInfo } from '../types/callback';
import { useTranslation } from 'react-i18next';

function capitalizeWords(str: string) {
  if (!str) return '';
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

const OnboardingFinish: React.FC = () => {
  const { t } = useTranslation();
  const userInfo: UserInfo = useMemo(
    () => JSON.parse(localStorage.getItem('oauthTokenResponse') || '{}'),
    [],
  );

  useEffect(() => {
    if (!(window as any).ReactNativeWebView && !('document' in userInfo)) {
      return;
    }
    (window as any).ReactNativeWebView.postMessage('user-onboarded');
  }, [userInfo]);

  const handleFinishClick = () => {
    localStorage.removeItem('oauthTokenResponse');
    localStorage.removeItem('access_token');
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage('close-webview');
    }
  };

  return (
    <div className="finish-container">
      <div className="finish-content">
        <div className="illustration-container">
          <img
            src="/images/onboardingFinish.png"
            alt="onboarding finish Illustration"
            className="finish-image"
          />
        </div>
        <h1 className="finish-title">{t('onboardingFinish.header')}</h1>
        <p className="finish-subtitle">{t('onboardingFinish.description')}</p>
        <div className="finish-details">
          <div className="detail-row">
            <span className="label">
              {t('onboardingFinish.userFields.name')}
            </span>
            <span className="value">
              {capitalizeWords(userInfo.nom) +
                ' ' +
                capitalizeWords(userInfo.cognoms)}
            </span>
          </div>
          <div className="detail-row">
            <span className="label">{t('onboardingFinish.userFields.id')}</span>
            <span className="value">{userInfo.document}</span>
          </div>
          <div className="detail-row">
            <span className="label">
              {t('onboardingFinish.userFields.phoneNumber')}
            </span>
            <span className="value">
              {userInfo.mobil_prefix &&
                `${userInfo.mobil_prefix.replace(/^0+/, '+')} ${
                  userInfo.mobil
                }`}
            </span>
          </div>
          <div className="detail-row">
            <span className="label">
              {t('onboardingFinish.userFields.device')}
            </span>
            <span className="value">{userInfo.dispositiu}</span>
          </div>
        </div>
        <ThemedButton text={t('global.ok')} onClick={handleFinishClick} />
      </div>
    </div>
  );
};

export default OnboardingFinish;
